export var isPatched = Symbol('@@federator/history-patch');
var addEventListener = window.addEventListener, removeEventListener = window.removeEventListener;
var events = ['popstate', 'pushState', 'replaceState'];
var forEachEvent = function (f) { return events.forEach(function (e) { return f(e); }); };
/**
 * Monkey patches history.pushState and history.replaceState to ensure that any
 * navigation will trigger appropriate app changes. Note: the `popstate` event
 * is NOT triggered via these methods, so (alas) we have to do this to ensure
 * that push/replace state calls trigger app changes as necessary.
 */
export function patch(history, method) {
    var original = history[method];
    if (original[isPatched])
        return;
    var patched = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        original.apply(history, args);
        window.dispatchEvent(new CustomEvent(method, { detail: { method: method } }));
    };
    patched[isPatched] = true;
    history[method] = patched;
}
patch(window.history, 'pushState');
patch(window.history, 'replaceState');
/**
 * Given a callback function, will start listening to the popstate, pushState,
 * and replaceState history events and invoke `listener` when an event occurs.
 * Returns a function that will stop listening when called.
 */
export function listenForHistoryChanges(listener) {
    var options = {
        once: false,
        capture: true,
        passive: false,
    };
    forEachEvent(function (e) { return addEventListener(e, listener, options); });
    return function () {
        forEachEvent(function (e) { return removeEventListener(e, listener, options); });
    };
}
//# sourceMappingURL=history.js.map